import { render, staticRenderFns } from "./AccordionServices.vue?vue&type=template&id=05360293"
import script from "./AccordionServices.vue?vue&type=script&lang=js"
export * from "./AccordionServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports